<div class="popup-container d-flex flex-column">
  @if(data.reachedBy!=null){
  <div>
    <label class="warning-text"> *Warning: </label>
    <label class="content"
      >This data is alredy reached by {{ data.reachedBy }}</label
    >
  </div>
  }
  <label class="heading-text">
    Are you sure you have reached ‘{{ data.name }}’?
  </label>
  <label class="content"
    >This is a critical action, please be sure before proceeding!</label
  >

  <div class="btn-div d-flex flex-column" (click)="testing()">
    <span class="heading-text">Notes*</span>
    <textarea
      class="note-inp dp-input-control"
      [formControl]="notes"
    ></textarea>
  </div>

  <div class="btn-div d-flex flex-column">
    <button class="dp-primary-btn btn-content" [disabled]="isLoading" (click)="onReachedClick()">
      <img  *ngIf="!isLoading" src="../../../assets/images/tick.svg" style="width: 18px; height: 18px;"/>
      <span *ngIf="!isLoading">Yes, Reach</span>
      <span *ngIf="isLoading"
       class="spin-reach"   [ngClass]="[isLoading ? 'spin' : '']"> Getting your location...
      </span>
    </button>
    <button class="dp-tertiary-btn btn-content" (click)="onCancelClick()">
      No, Cancel
    </button>
  </div>
</div>
